module.exports = __webpack_public_path__ + "static/media/password-protected-group.9ec0eed5.svg";